import React from "react";
import Form from "./Form";

function Contact() {
  return (
    <div name="enquiry">
      <Form />
    </div>
  );
}

export default Contact;
